manageSchools.$inject = ['graph', 'domainInfo', '$uibModal', 'auth']
import { Permissions } from '../client_auth/permissions'

export default function manageSchools(graph, domainInfo, $modal, auth) {
  return {
    restrict: 'EA',
    scope: {
      // domainUuid: '=',
    },
    link: function(scope, elm, attrs) {
      scope.ui = domainInfo.schoolsUI
      scope.usersUI = domainInfo.usersUI
      scope.domainInfo = domainInfo
      auth.hasUserOpsPermission().then(hasPermission => {
        scope.hasUserOpsPermission = hasPermission;
      });

      // create school modal
      scope.onSchoolCreated = function(school) {
        // reload list of schools
        domainInfo.refreshSchools()
        domainInfo.refreshSchoolAdmins()
      }
      scope.createSchoolModal = function() {
        var modalInstance = $modal.open({
          scope: scope,
          controller: [
            'domainUuid',
            '$uibModalInstance',
            function(domainUuid, $modalInstance) {
              this.domainUuid = domainUuid
              this.close = function() {
                $modalInstance.dismiss()
              }
              this.onSchoolCreated = function(school) {
                $modalInstance.close(school)
              }
            }
          ],
          controllerAs: 'modalCtrl',
          resolve: {
            domainUuid: function() {
              return domainInfo.domain.uuid
            }
          },
          template:
            '' +
            '<div class="modal-body">' +
            '<a class="close" ng-click="modalCtrl.close()">&times;</a>' +
            '<div create-school-entity domain-uuid="{{modalCtrl.domainUuid}}" on-school-created="modalCtrl.onSchoolCreated(school)"></div>' +
            '</div>'
        })
        modalInstance.result.then(scope.onSchoolCreated)
      }

      scope.handleMergeSuccess = function() {
        domainInfo.refreshSchools()
        domainInfo.refreshUsers()
      }
    },
    template: require('./_manageSchools.html')
  }
}
